var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"overview"},[_c('tips'),_c('xwallet-new'),_c('ubiquitous'),_c('private-wallet'),_c('dapp'),_c('telegram-chat'),_c('manage-assets'),_c('security')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }